import React, { useCallback, useEffect, useState } from 'react';
import { useDataPagination } from '@/utils/pagination';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import CmpPagination from '@/components/ui/Pagination';
import { WPLinks_COLORE, WPLinks_SIZE } from '@/data/wp/operations/queries/fragments/link';
import CardList from '@/components/fasce/CardList';
import { Button } from '@mui/material';
import useTranslation from 'next-translate/useTranslation';
//import { mapProductItemToCardList } from '@/data/hcl/sdk/utils';
import { mapPostAPIToCardList } from '@/data/wp/sdk/utils';

interface SearchResultGroupProps {
  type: string,
  title: string,
  showAll: boolean,
  showAllCallback: (type: string) => void,
  items: any,
  total: number,
  pending?: boolean,
}

/**
 * Gruppo di item, ragguppati per tipologia (es: Realizzazioni), ad uso della pagina di risultato ricerca.
 * Mostra Titolo, Counter, Mostra tutti e Paginazione.
 *
 * Prevede doppia modalità:
 * - Collassato: mostra solo i primi 4 items, senza paginazione
 * - Espanso: mostra tutti gli item paginati
 */
const SearchResultGroup: React.FC<SearchResultGroupProps> = ({ type, title, showAll, showAllCallback, items, total, pending = false }) => {
  const { t } = useTranslation('common');
  const [page, setPage] = useState(1);
  const pageSize = showAll ? parseInt(process.env.NEXT_PUBLIC_SEARCH_PAGE_SIZE || '50'): 4;
  const pagesCount = Math.ceil((total || 0) / pageSize);
  const totalResults = total;
  const enablePagination = showAll && pagesCount > 1;
  const paginatedData = useDataPagination(items, pageSize);

  const goToPage = useCallback((page: number) => {
    // Al momento il cambio di pagina avviene sui dati già prensenti nello state.
    // Non viene invocato nuovamente il servizio GraphQL
    setPage(page);
    paginatedData.jump(page);
  }, [paginatedData]);

  useEffect(() => {
    if (!showAll) {
      goToPage(1);
    }
  }, [showAll, goToPage]);

  if (!items) {
    return <></>
  }

  const currentPageData: any = type === 'projects' || type === 'contents' ? paginatedData.currentData()?.map(mapPostAPIToCardList): paginatedData.currentData();

  const showAllCta = showAll ? null: <Button variant="contained" color={WPLinks_COLORE.primary} size={WPLinks_SIZE.large} onClick={() => showAllCallback(type)}>
    {t(`search-result-viewall-${type}`, {}, {default: type})}
  </Button>;

  return <Box sx={{opacity: pending ? 0.6: 1 }}>

    <CardList
      title={title}
      cta={showAllCta}
      subtitleResults={totalResults}
      whiteCardList={currentPageData}
      hideImages={type === 'contents'}
    />

    {enablePagination &&
      <Container fixed sx={{ padding: '0 16px', mt: '80px' }}>
        <Stack direction="row">
          {/* @ts-ignore */}
          <CmpPagination page={page} numOfPage={pagesCount} onChange={(e: any, page: number) => goToPage(page)} />
        </Stack>
      </Container>
    }
  </Box>
}

export default SearchResultGroup;
